export default __webpack_public_path__ + "63bfeb19c838923c25c872dc10ab48c1.png";